
import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import Axios from '../../axios/axios';
import html2pdf from 'html2pdf.js';
import { toast } from 'react-toastify';

function PurchaseOrder() {
  const [orders, setOrders] = useState([]);
  const { id } = useParams();
  const [loadingId, setLoadingId] = useState(null);
  const poRef = useRef();
  const [customer, setCustomer] = useState(null);


  useEffect(() => {
    fetchCompletedOrders();
  }, []);



  const fetchCompletedOrders = async () => {
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    const customerId = userInfo?.customerId;
    const businessType = sessionStorage.getItem("businessType");
  
    if (!customerId || !businessType) return;
  
    try {
      const [ordersRes, customerRes] = await Promise.all([
        Axios.get(`${process.env.REACT_APP_API_URL}/order/given/${customerId}`),
        Axios.get(
          `${process.env.REACT_APP_API_URL}/customer/get/${customerId}`
        ),
      ]);
  
      const allOrders = ordersRes.data.orders || [];
      const filteredOrders = allOrders.filter(order =>
        order.businessType?.some(bt => bt.toLowerCase() === businessType.toLowerCase())
      );
  
      setOrders(filteredOrders);
      setCustomer(customerRes.data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  
  const handleDownloadPDF = (order) => {
    const element = poRef.current;
    const opt = {
      margin: 0.5,
      filename: `purchase_order_${order._id}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    
    // Create a temporary div with the PDF content
    const pdfContent = document.createElement('div');
    pdfContent.innerHTML = generatePDFContent(order);
    
    html2pdf().from(pdfContent).set(opt).save();
  };

  
  const generatePDFContent = (order) => {
    return `
      <div style="padding: 20px; border: 1px solid #ccc; background: white;">
        <h3 style="text-align:center; margin-bottom:20px;">PURCHASE ORDER</h3>
  
        <div style="display:flex; justify-content:space-between; margin-bottom:20px;">
          <div><strong>REFERENCE:</strong> ${order.orderNumber}</div>
          <div><strong>ORDER DATE:</strong> ${new Date(order.orderDate).toLocaleDateString()}</div>
        </div>
  
        <div style="display:flex; justify-content:space-between; margin-bottom:20px;">
          <div>
            <h5>Customer / Bill To:</h5>
            <p>
              ${customer.customerName || 'N/A'}<br />
              ${customer.address || 'N/A'}<br />
              Phone: ${customer.phoneNumber || 'N/A'}<br />
              Email: ${customer.email || 'N/A'}
            </p>
          </div>
          <div>
            <h5>Deliver To:</h5>
            <p>
              ${customer.customerName || 'N/A'}<br />
              ${customer.address || 'N/A'}<br />
              Phone: ${customer.phoneNumber || 'N/A'}<br />
              Email: ${customer.customerEmail || 'N/A'}
            </p>
          </div>
        </div>
  
        <div style="margin-bottom:20px;">
          <h5>Special Notes:</h5>
          <ul>
            <li>${order.note || 'Kindly acknowledge this order by return.'}</li>
            <li>Material must be brand new.</li>
            <li>Please provide your banking details for payment process.</li>
          </ul>
        </div>
  
        <div style="margin-bottom:20px;">
          <h5>Product Details:</h5>
          <table style="width:100%; border-collapse:collapse; text-align:center;">
            <thead>
              <tr style="background-color:#f2f2f2;">
                <th style="border:1px solid #ccc; padding:8px;">#</th>
                <th style="border:1px solid #ccc; padding:8px;">Product Name</th>
                <th style="border:1px solid #ccc; padding:8px;">Quantity</th>
                <th style="border:1px solid #ccc; padding:8px;">Unit Price (${order.currency})</th>
                <th style="border:1px solid #ccc; padding:8px;">Amount (${order.currency})</th>
              </tr>
            </thead>
            <tbody>
              ${order.orderItems.map((item, index) => `
                <tr>
                  <td style="border:1px solid #ccc; padding:8px;">${index + 1}</td>
                  <td style="border:1px solid #ccc; padding:8px;">${item.productName}</td>
                  <td style="border:1px solid #ccc; padding:8px;">${item.quantity}</td>
                  <td style="border:1px solid #ccc; padding:8px;">${item.unitPrice}</td>
                  <td style="border:1px solid #ccc; padding:8px;">${item.totalPrice}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
  
        <div style="text-align:right; margin-top:20px;">
          <p><strong>Subtotal (${order.currency}):</strong> ${order.totalAmount}</p>
          <p><strong>Sales Tax (${order.tax}%):</strong> ${order.taxAmount || (order.totalAmount * order.tax / 100).toFixed(2)}</p>
          <p><strong>Total Amount (${order.currency}):</strong> ${order.netAmount}</p>
        </div>
  
        <div style="margin-top:40px;">
          <p><strong>Approved By:</strong> ${order.approvedBy || 'Authorized Signatory'}</p>
          <p><strong>Date:</strong> ${new Date().toLocaleDateString()}</p>
          <p><strong>Authorized Signatory</strong></p>
        </div>
  
        <div style="margin-top:30px; font-size:12px; text-align:center; color:gray;">
          This purchase order is considered accepted by you in all respects if no objection is raised within 3 days from the order date.<br/>
          <br/>
          With best regards,<br/>
          For ${order.supplierName || 'Asia Part Souq'}
        </div>
      </div>
    `;
  };
  
  
  return (
    <div>
      <section id="inner-banner" className="purchaseHistory">
        <div className="container">
          <div className="mt-3 result-select">
            <div className="col-lg-12" style={{ marginTop: '150px' }}>
              <p className="movePages">
                <img src="/images/backIcon.svg" alt="back" />
                <Link to="/account" className="account">
                  {' '}
                  Account{' '}
                </Link>
                <a href="#"> Purchase order </a>
              </p>
              <div className="row no-gutters purchaseHisOptions">
                <div className="col-lg-6">
                  <h4 className="text-uppercase"> Purchase Order</h4>
                </div>
                <div className="col-lg-6">
                  <div className="form-row order-search">
                    <div className="col-lg-3 my-auto column-4 col-12 offset-lg-4"></div>
                    <div className="col-lg-2 my-auto column-3 col-6"></div>
                    <div className="col-lg-3 my-auto column-4 col-6">
                      <a
                        href="#"
                        className="export"
                        style={{ textDecoration: 'none' }}
                      >
                        <span>
                          Export as PDF &nbsp;&nbsp;
                          <img src="/images/pdf.png" alt="pdf" />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Hidden PDF content */}
              <div ref={poRef} style={{ display: 'none' }}></div>

              {orders.length > 0 ? (
                orders.map((order) => (
                  <div key={order._id}>
                    <div className="historyHeading">
                      <div className="row">
                        <div className="col-md-4">
                          <p>
                            Purchase ID: <b>#{order._id}</b>
                          </p>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-6">
                            <p className="orderDate">
                              Ordered on{' '}
                              {new Date(order.orderDate).toDateString()}
                            </p>
                          </div>
                          <div className="col-md-6 text-end">
                            <button
                              className="btn btn-outline-danger"
                              onClick={() => handleDownloadPDF(order)}
                            >
                              <i className="fas fa-file-pdf"></i> Download PDFas
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="historyContent">
                      <div className="row">
                        <div className="col-md-6">
                          <table className="table">
                            <thead>
                              <tr>
                                <th scope="col">Items</th>
                              </tr>
                            </thead>
                            <tbody>
                              {order.orderItems.map((item) => (
                                <tr key={item._id}>
                                  <td>{item.productName}</td>
                                  <td>Qty: {item.quantity}</td>
                                  <td>
                                    {order.currency} {item.totalPrice}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div className="col-md-5 orderSummary">
                          <table className="table">
                            <thead>
                              <tr>
                                <th scope="col">Order summary</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Sub total</td>
                                <td>
                                  {order.currency} {order.totalAmount}
                                </td>
                              </tr>
                              <tr>
                                <td>Tax</td>
                                <td>{order.tax} %</td>
                              </tr>
                              <tr>
                                <td>Payment Status</td>
                                <td>{order.paymentStatus}</td>
                              </tr>
                              <tr>
                                <td>Total</td>
                                <td>
                                  {order.currency} {order.netAmount}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-md-8 deliveryAddress">
                        <h6>Delivery address</h6>
                        <p>
                          {order.customerName}
                          <br />
                          {order.customerEmail}
                          <br />
                          {order.phoneNumber}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No purchase order found.</p>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PurchaseOrder;







